import React from 'react';
import ReactECharts from 'echarts-for-react';
import { format, subDays, eachDayOfInterval, startOfMonth, endOfMonth } from 'date-fns';

const PaymentPulseChart = ({ payments }) => {
  const today = new Date();
  const monthStart = startOfMonth(today);
  const monthEnd = endOfMonth(today);
  
  const days = eachDayOfInterval({ start: monthStart, end: today });
  
  const dailyData = days.map(day => {
    const dayStr = format(day, 'yyyy-MM-dd');
    const collected = payments
      .filter(p => p.status === 'Paid' && p.paymentDate === dayStr)
      .reduce((sum, p) => sum + p.amount, 0);
    
    return {
      date: format(day, 'MMM dd'),
      amount: collected
    };
  });

  const option = {
    tooltip: {
      trigger: 'axis',
      formatter: '{b}<br/><b>Collected: ${c}</b>',
      backgroundColor: '#111827',
      textStyle: { color: '#fff' }
    },
    grid: { left: '3%', right: '4%', bottom: '3%', top: '10%', containLabel: true },
    xAxis: {
      type: 'category',
      data: dailyData.map(d => d.date),
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: { color: '#9CA3AF', fontSize: 10 }
    },
    yAxis: {
      type: 'value',
      axisLabel: { formatter: '${value}', color: '#9CA3AF', fontSize: 10 },
      splitLine: { lineStyle: { type: 'dashed', color: '#F3F4F6' } }
    },
    series: [
      {
        data: dailyData.map(d => d.amount),
        type: 'line',
        smooth: true,
        symbol: 'circle',
        symbolSize: 8,
        itemStyle: { color: '#10B981' },
        lineStyle: { width: 4, color: '#10B981' },
        areaStyle: {
          color: {
            type: 'linear',
            x: 0, y: 0, x2: 0, y2: 1,
            colorStops: [
              { offset: 0, color: 'rgba(16, 185, 129, 0.2)' },
              { offset: 1, color: 'rgba(16, 185, 129, 0)' }
            ]
          }
        }
      }
    ]
  };

  return (
    <div className="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xs font-black text-gray-400 uppercase tracking-widest">Live Collection Pulse</h3>
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
          <span className="text-[10px] font-black text-green-600 uppercase">Real-Time Sync</span>
        </div>
      </div>
      <div className="h-[250px]">
        <ReactECharts option={option} style={{ height: '100%' }} />
      </div>
    </div>
  );
};

export default PaymentPulseChart;